// extracted by mini-css-extract-plugin
export default {"book-column":"bookColumn_book-column__f6WQ6","tabs":"bookColumn_tabs__FZEOV"};